import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import * as mapboxgl from 'mapbox-gl';
import { environment } from "src/environments/environment";
import * as turf from '@turf/turf';
import * as MapboxDraw from "@mapbox/mapbox-gl-draw";
import { ExtendDrawBar } from "../helper/class/extended-toolbar";
import { IAddPolygonParams, IGeoJSONObj, IMapBasicParams, IMapBuild, IMarkerModel } from "../models/interfaces/map-fn-props";
import { ICoords } from "../models/interfaces/coords";
import * as MapboxDrawGeodesic from 'mapbox-gl-draw-geodesic';
import { LocationService } from "./location.service";




/**
 *              -------ÖNEMLİ------
 * 
 *      harita için eklenen listenerları off etmek için, on aşamasında kullanılan 
 *  callback fonksiyonu kullanılmalı. Aksi taktirde listener kapatılmıyor ve hata da almıyorsunuz.
 *  Arka arkaya tekrar açılıyor.
 * 
 * 
 * 
 */
@Injectable({
    providedIn: "any"
})
export class MapService {
    isFlying: boolean = false;
    isFiliz: boolean = false;
    style = 'mapbox://styles/mstfcinar/clav3s3no003z15mkm7k7yl21';
    stylesFiliz = [
        // ACTIVE (being drawn)
        // line stroke
        {
            "id": "gl-draw-line",
            "type": "line",
            "filter": ["all", ["==", "$type", "LineString"], ["!=", "mode", "static"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#FFFFFF",
                "line-dasharray": [1],
                "line-width": 4
            }
        },
        // polygon fill
        {
            "id": "gl-draw-polygon-fill",
            "type": "fill",
            "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
            "paint": {
                "fill-color": "#4c9a31",
                "fill-outline-color": "#4c9a31",
                "fill-opacity": 0.34
            }
        },
        // polygon mid points
        {
            'id': 'gl-draw-polygon-midpoint',
            'type': 'circle',
            'filter': ['all',
                ['==', '$type', 'Point'],
                ['==', 'meta', 'midpoint']],
            'paint': {
                'circle-radius': 6,
                'circle-color': '#FFFFFF'
            }
        },
        // polygon outline stroke
        // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
        {
            "id": "gl-draw-polygon-stroke-active",
            "type": "line",
            "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#FFFFFF",
                "line-dasharray": [1],
                "line-width": 3
            }
        },
        // vertex point halos
        {
            "id": "gl-draw-polygon-and-line-vertex-halo-active",
            "type": "circle",
            "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
            "paint": {
                "circle-radius": 11,
                "circle-color": "#FFFFFF"
            }
        },
        // vertex points
        {
            "id": "gl-draw-polygon-and-line-vertex-active",
            "type": "circle",
            "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
            "paint": {
                "circle-radius": 10,
                "circle-color": "#4c9a31"
            }
        },

        // INACTIVE (static, already drawn)
        // line stroke
        {
            "id": "gl-draw-line-static",
            "type": "line",
            "filter": ["all", ["==", "$type", "LineString"], ["==", "mode", "static"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#000",
                "line-width": 3
            }
        },
        // polygon fill
        {
            "id": "gl-draw-polygon-fill-static",
            "type": "fill",
            "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
            "paint": {
                "fill-color": "#000",
                "fill-outline-color": "#000",
                "fill-opacity": 0.1
            }
        },
        // polygon outline
        {
            "id": "gl-draw-polygon-stroke-static",
            "type": "line",
            "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#000",
                "line-width": 3
            }
        }
    ]
    stylesTrap = [
        // ACTIVE (being drawn)
        // line stroke
        {
            "id": "gl-draw-line",
            "type": "line",
            "filter": ["all", ["==", "$type", "LineString"], ["!=", "mode", "static"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#FFFFFF",
                "line-dasharray": [1],
                "line-width": 4
            }
        },
        // polygon fill
        {
            "id": "gl-draw-polygon-fill",
            "type": "fill",
            "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
            "paint": {
                "fill-color": "#8483b0",
                "fill-outline-color": "#8483b0",
                "fill-opacity": 0.34
            }
        },
        // polygon mid points
        {
            'id': 'gl-draw-polygon-midpoint',
            'type': 'circle',
            'filter': ['all',
                ['==', '$type', 'Point'],
                ['==', 'meta', 'midpoint']],
            'paint': {
                'circle-radius': 6,
                'circle-color': '#FFFFFF'
            }
        },
        // polygon outline stroke
        // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
        {
            "id": "gl-draw-polygon-stroke-active",
            "type": "line",
            "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#FFFFFF",
                "line-dasharray": [1],
                "line-width": 3
            }
        },
        // vertex point halos
        {
            "id": "gl-draw-polygon-and-line-vertex-halo-active",
            "type": "circle",
            "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
            "paint": {
                "circle-radius": 11,
                "circle-color": "#FFFFFF"
            }
        },
        // vertex points
        {
            "id": "gl-draw-polygon-and-line-vertex-active",
            "type": "circle",
            "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
            "paint": {
                "circle-radius": 10,
                "circle-color": "#8483b0"
            }
        },

        // INACTIVE (static, already drawn)
        // line stroke
        {
            "id": "gl-draw-line-static",
            "type": "line",
            "filter": ["all", ["==", "$type", "LineString"], ["==", "mode", "static"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#000",
                "line-width": 3
            }
        },
        // polygon fill
        {
            "id": "gl-draw-polygon-fill-static",
            "type": "fill",
            "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
            "paint": {
                "fill-color": "#000",
                "fill-outline-color": "#000",
                "fill-opacity": 0.1
            }
        },
        // polygon outline
        {
            "id": "gl-draw-polygon-stroke-static",
            "type": "line",
            "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
            "layout": {
                "line-cap": "round",
                "line-join": "round"
            },
            "paint": {
                "line-color": "#000",
                "line-width": 3
            }
        }
    ]
    /**
     *
     */
    constructor() {
        // mapboxgl.accessToken = environment.mapbox.accessToken;

    }

    buildMap(prop: IMapBuild): Observable<mapboxgl.Map> {
        let returnMap;
        return new Observable(observer => {
            let options: any = {
                container: prop.mapId,
                accessToken: environment.mapbox.accessToken
            }
            if (prop.style)
                options.style = prop.style
            if (prop.zoom)
                options.zoom = prop.zoom
            if (prop.center)
                options.center = [prop.center.lng, prop.center.lat]
            returnMap = new mapboxgl.Map(options);
            returnMap.on('load', () => {
                // returnMap.resize()
                // returnMap.addControl(new mapboxgl.FullscreenControl());
                // returnMap.addControl(new mapboxgl.NavigationControl());
                prop.onLoadCallback(returnMap);
            });
            let div = document.getElementsByClassName("mapboxgl-ctrl-bottom-right")[0];
            div.setAttribute("style", "display:none");
            let div2 = document.getElementsByClassName("mapboxgl-ctrl-bottom-left")[0];
            div2.setAttribute("style", "display:none");
            observer.next(returnMap);
        });
    }

    destroyMap(map: mapboxgl.Map) {
        map.remove()
    }

    public resizeMap(map) {
        map = map.resize();
        return map
    }

    public mapAddNavigationCtrl(map) {
        map.addControl(new mapboxgl.NavigationControl())
        return map
    }
    public mapAddFullscreenCtrl(map) {
        map.addControl(new mapboxgl.FullscreenControl())
        return map
    }

    public addDrawControls(map, scope, callback) {
        // Darwing
        const modes = MapboxDraw.modes;

        let draw = new MapboxDraw({
            displayControlsDefault: false,
            controls: {
                trash: true
            },
        });
        var drawBar = new ExtendDrawBar({
            scope: scope,
            draw: draw,
            buttons: [{
                on: 'click',
                action: () => {
                    draw.changeMode("draw_polygon");
                },
                classes: [],
                content: '<span><i class="fas fa-square"></i></span>'
            }]
        });
        map.addControl(drawBar);
        callback(map)
        // Darawing END
    }

    //TODO click yerine touchStart eventı tetiklendiği durumlarda
    // mapbox-gl-draw.js:1 Unable to preventDefault inside passive event listener invocation.
    // şeklinde bir hata dönüyor. draw event listenerları çalışıyor sorunsuz
    public drawPolygon(props: IMapBasicParams, deviceType) {
        // let modes = MapboxDraw.modes;
        // modes = MapboxDrawGeodesic.enable(modes);
        const draw = new MapboxDraw({
            displayControlsDefault: false,
            touchEnabled: true,
            boxSelect: false,
            userProperties: true,
            controls: {
                // trash: true
            },
            styles: deviceType == 'filiz' ? this.stylesFiliz : this.stylesTrap,
            defaultMode: 'draw_polygon'
        })

        props.map.addControl(draw);

        props.map.on('draw.create', props.callback)
        props.map.on('draw.delete', props.callback)
        props.map.on('draw.update', props.callback)
        props.map.on('draw.render', props.callback)
        // props.map.on('draw.combine',props.callback)
        // props.map.on('draw.uncombine',props.callback)
        props.map.on('draw.modechange', props.callback)
        props.map.on('draw.actionable', props.callback)
        props.map.on('draw.selectionchange', props.callback)

        return draw
    }
    public customDrawPolygon(props: IMapBasicParams, deviceType, vertextListener: Observable<any>): Observable<any> {
        props.map = props.map as mapboxgl.Map
        return new Observable(observer => {
            let drawingMarkersArray: Array<mapboxgl.Marker> = []
            let lineStringsArray: Array<{ source: string, layer: string }> = []
            let polygonCoordinates: Array<Array<number>> = []
            // let idArray = [];


            let deleteFn = () => {
                if (lineStringsArray.length > 0) {
                    let lastLineString = lineStringsArray.pop();
                    props.map.removeLayer(lastLineString.layer);
                    props.map.removeSource(lastLineString.source);
                }
                if (drawingMarkersArray.length > 0) {
                    let lastMarker = drawingMarkersArray.pop();
                    lastMarker.remove();
                }
                // if (idArray.length > 1) {
                //     idArray.pop();
                //     let lastMarkerId = idArray[idArray.length - 1];
                //     document.getElementById(lastMarkerId).classList.add("last-marker");
                // }
                if (polygonCoordinates.length >= 3) {
                    this._removeDrawingPolygonShape(props.map)
                    polygonCoordinates.pop()
                    if (polygonCoordinates.length > 2) {
                        this._createDrawingPolygonShape(props.map, polygonCoordinates)
                    }

                } else if (polygonCoordinates.length === 2) {
                    this._removeDrawingPolygonShape(props.map)
                    polygonCoordinates.pop()
                } else if (polygonCoordinates.length > 0) {
                    polygonCoordinates.pop()
                }
                let geojsobObj: IGeoJSONObj = {
                    geometry: {
                        coordinates: [[...polygonCoordinates, polygonCoordinates[0]]],
                        type: "Polygon"
                    },
                    properties: {},
                    type: "Feature"
                }
                observer.next({ state: "last_vertex_deleted", data: geojsobObj })
            }

            let clickListenerFn = ev => {
                var doc = document.createElement('div');
                doc.className = "farm-drawing-marker";
                doc.id = 'drawingMarker_' + drawingMarkersArray.length + "_" + Date.now();
                // idArray.push(doc.id);
                if (drawingMarkersArray.length === 0) {
                    doc.className = "farm-drawing-marker first-marker";
                    doc.addEventListener('click', function (e) {
                        // Prevent the `map.on('click')` from being triggered
                        e.stopPropagation();
                        finishDrawingBeginUpdate()
                    });
                } else {
                    //last markerın renginin değişmesi için yapıldı.
                    // idArray.forEach((id, index) => {
                    //     if (index < idArray.length - 1) {
                    //         document.getElementById(id).classList.remove("last-marker");
                    //     }
                    // });
                    let lastMarker = drawingMarkersArray[drawingMarkersArray.length - 1];
                    let lineIdSuffix = lineStringsArray.length + "_" + Date.now()
                    props.map.addSource(`route_${lineIdSuffix}`, {
                        type: "geojson",
                        data: {
                            type: "Feature",
                            properties: {},
                            geometry: {
                                type: "LineString",
                                coordinates: [
                                    [ev.lngLat.lng, ev.lngLat.lat],
                                    [lastMarker.getLngLat().lng, lastMarker.getLngLat().lat]
                                ]
                            }
                        }
                    })
                    props.map.addLayer({
                        id: `linestring_${lineIdSuffix}`,
                        type: "line",
                        source: `route_${lineIdSuffix}`,
                        layout: {
                            "line-cap": "round",
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#FFF",
                            "line-width": 3,
                            "line-dasharray": [3, 2, 3, 2]
                        }
                    })
                    lineStringsArray.push({ source: `route_${lineIdSuffix}`, layer: `linestring_${lineIdSuffix}` })

                }
                let markerObj = new mapboxgl.Marker(doc, { anchor: "center" })
                markerObj.setLngLat([ev.lngLat.lng, ev.lngLat.lat])
                markerObj.addTo(props.map)
                drawingMarkersArray.push(markerObj)

                polygonCoordinates.push([ev.lngLat.lng, ev.lngLat.lat])
                let geojsobObj: IGeoJSONObj = {
                    geometry: {
                        coordinates: [[...polygonCoordinates, polygonCoordinates[0]]],
                        type: "Polygon"
                    },
                    properties: {},
                    type: "Feature"
                }
                if (drawingMarkersArray.length >= 3) {
                    this._removeDrawingPolygonShape(props.map)
                    this._createDrawingPolygonShape(props.map, polygonCoordinates)
                    if (this.checkIfCoordsCross([[...polygonCoordinates, polygonCoordinates[0]]]))
                        observer.next({ state: "linesCrossed", data: geojsobObj })
                    else
                        observer.next({ state: "render", data: geojsobObj })
                } else
                    observer.next({ state: "start", data: geojsobObj })
            }

            props.map = props.map.on('click', clickListenerFn)

            var finishDrawingBeginUpdate = () => {
                this._removeDrawingPolygonShape(props.map);
                drawingMarkersArray.forEach(el => {
                    el.remove();
                })
                lineStringsArray.forEach(el => {
                    if (props.map.getLayer(el.layer))
                        props.map.removeLayer(el.layer);
                    if (props.map.getSource(el.source))
                        props.map.removeSource(el.source);
                });
                drawingMarkersArray = []
                lineStringsArray = []
                let drawingObj = new MapboxDraw({
                    displayControlsDefault: false,
                    touchEnabled: true,
                    boxSelect: false,
                    userProperties: true,
                    controls: {
                        // trash: true
                    },
                    styles: deviceType == 'filiz' ? this.stylesFiliz : this.stylesTrap,
                    defaultMode: 'draw_polygon',
                })
                props.map.addControl(drawingObj)
                props.map.on('draw.delete', props.callback)
                props.map.on('draw.update', props.callback)
                props.map.on('draw.render', props.callback)
                let geojsonCoords: any = [...polygonCoordinates, polygonCoordinates[0]]
                let featureId = "drawing_item_" + Math.ceil(Math.random() * 1000)
                let geojsonObj: GeoJSON.Feature = {
                    geometry: {
                        type: "Polygon",
                        coordinates: [geojsonCoords]
                    },
                    id: featureId,
                    properties: {},
                    type: "Feature"
                }
                drawingObj.add(geojsonObj)
                drawingObj.changeMode("direct_select", { featureId })
                // props.callback(drawingObj)
                observer.next({ state: "finished", data: geojsonObj, draw: drawingObj })
                polygonCoordinates = []
                deleteVertexListener.unsubscribe()
                deleteVertexListener = undefined
                props.map = props.map.off("click", clickListenerFn)
                observer.complete();
            }

            var deleteVertexListener = vertextListener.subscribe(res => {
                switch (res.state) {
                    case "delete":
                        deleteFn()
                        break;
                    case "complete":
                        finishDrawingBeginUpdate()
                        break;
                    default:
                        break;
                }
            })
        })
    }
    public checkIfPolygonLinesCross(draw: MapboxDraw) {
        let geojson = draw.getAll()
        let turfPolygon = turf.polygon(geojson.features[0].geometry["coordinates"])
        let turfKink = turf.kinks(turfPolygon)
        return turfKink.features.length > 0
    }
    private _removeDrawingPolygonShape(map) {
        if (map.getLayer("polgonDrawingItemLayer"))
            map.removeLayer("polgonDrawingItemLayer")
        if (map.getSource("polgonDrawingItemSource"))
            map.removeSource("polgonDrawingItemSource")
    }

    calculateAreaFromGeoJson(geojson: IGeoJSONObj) {
        const area = turf.area(geojson.geometry) * 0.001;
        const rounded_area = Math.round(area * 1000) / 1000;

        return rounded_area
    }
    public checkIfCoordsCross(prop: number[][][]) {
        let turfPolygon = turf.polygon(prop)
        let turfKink = turf.kinks(turfPolygon)
        return turfKink.features.length > 0
    }
    private _createDrawingPolygonShape(map: mapboxgl.Map, coordinates) {
        let geojsonCoords: any = [...coordinates, coordinates[0]]
        map.addSource("polgonDrawingItemSource", {
            type: "geojson",
            data: {
                type: "Feature",
                properties: {},
                geometry: {
                    type: "Polygon",
                    coordinates: [geojsonCoords]
                }
            }
        })
        let isCross = this.checkIfCoordsCross([geojsonCoords]);
        map.addLayer({
            id: "polgonDrawingItemLayer",
            type: "fill",
            source: "polgonDrawingItemSource",
            layout: {},
            paint: {
                'fill-color': !isCross ? environment.mapLayerStyle.fillColor : '#EF4444', //'#0080ff', // blue color fill
                'fill-opacity': 0.24//0.5
            }
        })
    }

    public clickToGetCoords(props: IMapBasicParams) {
        props.map.on("click", props.callback)
        return props.map
    }

    public removeEvent<T extends IMapBasicParams & { eventName: string }>(props: T) {
        props.map.off(props.eventName, props.callback)
    }

    /**
     * tüm geojsonları tek layer olarak haritaya yükler.
     */

    addRaster<T extends IMapBasicParams & { id: number }>(props: T) {
        if (props.id) {
            if (!props.map.getSource("rainviewer_source" + props.id)) {

                props.map.addSource("rainviewer_source" + props.id, {
                    type: "raster",
                    tiles: [
                        "https://tilecache.rainviewer.com/v2/radar/" + props.id + "/256/{z}/{x}/{y}/2/1_1.png"
                    ],
                    'tileSize': 256
                });

                setTimeout(() => {
                    if (!props.map.getLayer("rainviewer_layer" + props.id)) {
                        props.map.addLayer({
                            id: "rainviewer_layer" + props.id,
                            type: "raster",
                            source: "rainviewer_source" + props.id
                        });
                    }

                });
            }
        }


    }

    removeRaster<T extends IMapBasicParams & { id: number }>(props: T) {
        if (props.map.getLayer("rainviewer_layer" + props.id)) {
            props.map.removeLayer("rainviewer_layer" + props.id);
        }
        if (props.map.getSource("rainviewer_source" + props.id))
            props.map.removeSource("rainviewer_source" + props.id);

    }

    public clearMarkersLayer(props: { map: mapboxgl.Map, tempFarmAttId, callback }) {
        let sourceId = `${props.tempFarmAttId}_notes`;
        props.map.off("click", `${sourceId}_layer`, props.callback)
        if (props.map.getLayer(`${sourceId}_layer`))
            props.map.removeLayer(`${sourceId}_layer`)
        if (props.map.getSource(`${sourceId}_source`))
            props.map.removeSource(`${sourceId}_source`)
    }
    public addPolygonsAllAtOnce<T extends IMapBasicParams & IAddPolygonParams & { geojsons: Array<IGeoJSONObj>, color?: string }>(props: T) {
        let colorInfo = props.color ? props.color : environment.mapLayerStyle.fillColor;
        let sourceData = {
            type: "geojson",
            data: {
                'type': 'FeatureCollection',
                'features': props.geojsons
            }
        }
        let map: mapboxgl.Map
        let sourceId = "all_farms"
        if (props.map.getSource(sourceId)) {
            props.map.removeLayer(`${sourceId}_polygons`)
            props.map.removeLayer(`${sourceId}_points`)
            props.map.removeLayer(`${sourceId}_outline`)
            props.map.removeSource(sourceId)
        }
        props.map.addSource(sourceId, sourceData)
        props.map.addLayer({
            id: `${sourceId}_polygons`,
            type: "fill",
            source: sourceId,
            layout: {},
            minzoom: environment.homeMapZoomLimit,
            paint: {
                'fill-color': colorInfo, //'#0080ff', // blue color fill
                'fill-opacity': environment.mapLayerStyle.opacity//0.5
            },
            filter: ['==', '$type', 'Polygon']
        })
        props.map.addLayer({
            'id': `${sourceId}_points`,
            'type': 'circle',
            'source': sourceId,
            minzoom: environment.homeMapZoomLimit,
            'paint': {
                'circle-radius': 8,
                'circle-stroke-width': 2,
                'circle-color': 'red',
                'circle-stroke-color': 'white'
            },
            'filter': ['==', '$type', 'Point']
        });
        props.map.addLayer({
            'id': `${sourceId}_outline`,
            'type': 'line',
            'source': sourceId,
            'layout': {
            },
            minzoom: environment.homeMapZoomLimit,
            'paint': {
                'line-color': environment.mapLayerStyle.lineColor, // '#000',
                'line-width': environment.mapLayerStyle.lineWidth // 3
            },
            filter: ['==', '$type', 'Polygon']
        })


        if (props.callback && props.addClickEvent) {
            props.map.on("click", sourceId + "_points", props.callback)

            props.map.on("click", sourceId + "_polygons", props.callback)

        }

        return props.map;
    }

    public addMarkerPin(props: IMapBasicParams & IMarkerModel & { markerIcon?}) {
        const el = document.createElement('div');
        el.style.backgroundImage = "url(/assets/images/" + props.markerIcon + "-flag.svg)";
        el.className = "marker";
        el.style.backgroundSize = 'cover';
        el.style.backgroundRepeat = 'no-repeat';
        let markerObj: mapboxgl.Marker = new mapboxgl.Marker(
            el, { offset: [0, 0] })
            .setLngLat([props.coords.longitude, props.coords.latitude])
            .addTo(props.map);
        markerObj.setDraggable(true)
        markerObj.on("dragend", props.callback)
        return markerObj;
    }

    // public async followMyLocation(props: { map: mapboxgl.Map, icon: any, id: string }) {
    //     if (!props.id)
    //         props.id = "my-location-pulse"
    //     if (!props.icon) {
    //         let doc = document.createElement("div")
    //         doc.className = "blob blue";
    //         doc.id = props.id;
    //         props.icon = doc;
    //     }
    //     let markerObj = new mapboxgl.Marker(props.icon, { anchor: "center" })
    //     let currentCoords = (await LocationService.GetMyCurrentLocation()).Data
    //     markerObj.setLngLat([currentCoords.longitude, currentCoords.latitude])
    //     markerObj.setDraggable(false)
    //     markerObj.addTo(props.map)
    //     // this.locationService.WatchMyLocation().subscribe(response => {
    //     //     if (response?.coords && response.coords.longitude > 0 && response.coords.latitude > 0)
    //     //         markerObj.setLngLat([response.coords.longitude, response.coords.latitude])
    //     // }, err => {
    //     // })

    // }

    public async followMyLocation(props: { map: mapboxgl.Map, icon: any, id: string }) {

        if (!props.id)
            props.id = "my-location-pulse"
        if (!props.icon) {

            let doc: any = document.getElementById(props.id)//document.createElement("div")
            if (!doc)
                doc = document.createElement("div")
            doc.className = "blob blue";
            doc.id = props.id;
            props.icon = doc;
        }
        let markerObj = new mapboxgl.Marker(props.icon, { anchor: "center" })
        let currentCoords = {} as any
        try {
            currentCoords = (await LocationService.GetMyCurrentLocation()).Data
        } catch (error) {
            try {
                currentCoords = await LocationService.GetLocationFromIp()
            } catch (error) {
                currentCoords = { longitude: 39.9035557, latitude: 32.6226818 }
            }

        }
        markerObj.setLngLat([currentCoords.longitude, currentCoords.latitude])
        markerObj.setDraggable(false)
        markerObj.addTo(props.map)
        LocationService.WatchMyLocation().subscribe(response => {
            if (response?.coords && response.coords.longitude > 0 && response.coords.latitude > 0)
                markerObj.setLngLat([response.coords.longitude, response.coords.latitude])
        }, err => {
        })

    }
    public addPolygonToMap<T extends IMapBasicParams & IAddPolygonParams & { item: any } & { longPressCallback }>(props: T) {
        // if (!props.polygonId)
        // props.polygonId = Date.now()
        // var id = `${props.polygonId}`
        let sourceGeoJSON = {
            type: "geojson",
            data: props.geojson
        }
        props.map.addSource(props.polygonId, sourceGeoJSON)
        props.map.addLayer({
            id: props.polygonId,
            type: "fill",
            source: props.polygonId,
            layout: {},
            paint: {
                'fill-color': props.item.fillColor, //'#0080ff', // blue color fill
                'fill-opacity': environment.mapLayerStyle.opacity//0.5
            }
        })
        // Add a black outline around the polygon.
        props.map.addLayer({
            'id': `${props.polygonId}_outline`,
            'type': 'line',
            'source': props.polygonId,
            'layout': {},
            'paint': {
                'line-color': environment.mapLayerStyle.lineColor, // '#000',
                'line-width': environment.mapLayerStyle.lineWidth // 3
            }
        })
        if (props.callback && props.addClickEvent) {
            props.map.on("click", props.polygonId,
                props.callback
                // this.sendEventResponse
                // (ev) => {
                //     callback(ev)
                // }
            )
        }
        if (props.longPressCallback) {
            let map: mapboxgl.Map = props.map;
            let timerInterval;
            let passedTime = 0;
            props.map.on("touchstart", props.polygonId, props.longPressCallback
            )
            props.map.on("touchend", props.polygonId, props.longPressCallback
            )
            map.on("move", props.longPressCallback
            )
            map.on("zoom", props.longPressCallback
            )
        }
        return props.map;
    }

    addBorder<T extends IMapBasicParams & IAddPolygonParams>(props: T) {
        props.map.addLayer({
            'id': "border",
            'type': 'line',
            'source': props.polygonId,
            'layout': {},
            'paint': {
                'line-color': "#FCED50", // '#000',
                'line-width': environment.mapLayerStyle.lineWidth // 3
            }
        })
    }

    public addClickEventToLayer<T extends IMapBasicParams & { layerId: string }>(props: T) {
        props.map.on("click", props.layerId,
            props.callback
            // this.sendEventResponse
            // (ev) => {
            //     callback(ev)
            // }
        )
        return props.map
    }

    removeLayer<T extends IMapBasicParams & { id: string }>(props: T) {
        if (props.map.getLayer(props.id)) {
            props.map.removeLayer(props.id);
        }
    }

    removeSource<T extends IMapBasicParams & { id: string }>(props: T) {
        if (props.map.getSource(props.id))
            props.map.removeSource(props.id);
    }

    public addDrawablePolygon(props: IMapBasicParams & IAddPolygonParams, deviceType) {
        const draw = new MapboxDraw({
            displayControlsDefault: false,
            touchEnabled: true,
            boxSelect: false,
            userProperties: true,
            controls: {
                // trash: true
            },
            styles: deviceType == 'filiz' ? this.stylesFiliz : this.stylesTrap,
            defaultMode: 'simple_select'// 'draw_polygon'
        })
        props.map.addControl(draw);
        props.map.on('draw.create', props.callback)
        props.map.on('draw.delete', props.callback)
        props.map.on('draw.update', props.callback)
        props.map.on('draw.render', props.callback)
        let featuresId = draw.add(props.geojson.geometry as any)
        draw.changeMode("direct_select", { featureId: featuresId[0] })
        return { draw, map: props.map }
    }

    public setMyLocationPin<T extends IMapBasicParams & IMarkerModel & { icon?: any, id?: string }>(props: T) {
        if (!props.id)
            props.id = "my-location-pulse"
        if (!props.icon) {
            let doc = document.createElement("div")
            doc.className = "blob blue";
            doc.id = props.id;
            props.icon = doc;
        }
        let markerObj = props.currentMarker || new mapboxgl.Marker(props.icon, { anchor: "bottom" })
        markerObj.setLngLat([props.coords.longitude, props.coords.latitude])
        markerObj.addTo(props.map)
        return markerObj;
    }


    public flyToLocation<T extends IMapBasicParams & ICoords>(props: T) {
        let map: mapboxgl.Map = props.map
        let options: mapboxgl.FlyToOptions = {
            animate: true,
            center: { lng: props.longitude, lat: props.latitude },
            zoom: 15
        }
        map.flyTo(options)
        return map
    }

    flyTo(map: any, center: any, zoom: any): Observable<any> {
        return new Observable(observer => {
            map?.on("moveend", (e) => {
                if (this.isFlying) {
                    observer.next(e);
                    this.isFlying = false;
                }
            });
            map?.flyTo({
                center: [
                    center.lng,
                    center.lat
                ],
                essential: true,
                zoom: zoom
            });
            this.isFlying = true;
        });
    }


    public fitBounds(props) {
        let map: mapboxgl.Map = props.map
        let bounds = new mapboxgl.LngLatBounds(props.geojson.geometry.coordinates[0][0], props.geojson.geometry.coordinates[0][0]);
        props.geojson.geometry.coordinates[0].forEach(element => {
            bounds.extend(element);
        });
        map.fitBounds(bounds, { padding: props.padding })
    }

    public fitAllFarmBounds(centerList: Array<any>, map: any) {
        var bounds = new mapboxgl.LngLatBounds();
        centerList.forEach((center) => {
            bounds.extend(center);
        });
        map.fitBounds(bounds);
    }

    public getBounds(geojson) {
        let bounds = new mapboxgl.LngLatBounds(geojson.geometry.coordinates[0][0], geojson.geometry.coordinates[0][0]);
        geojson.geometry.coordinates[0].forEach(element => {
            bounds.extend(element);
        });
        return bounds
    }


    public deleteAndRedraw<T extends IMapBasicParams & { draw: MapboxDraw }>(props: T) {
        props.draw.trash()
        props.draw.changeMode("draw_polygon")
        props.draw.getDefaultPosition()
        return props.draw
        // throw new Error('Method not implemented.');
    }

    public deleteLastVertex(props: any) {
        throw new Error('Method not implemented.');
        let feature = props.draw.getAll().features[0]
        props.draw.changeMode("direct_select", { featureId: feature.id })
        props.draw.deleteAll()
        // props.map.removeControl(props.draw)
        let coords: Array<any> = feature.geometry.coordinates[0].filter(t => true)
        let popoedCoord = coords.pop();
        feature.geometry.coordinates[0] = coords.filter(t => true)
        // const newDraw = new MapboxDraw({
        //     displayControlsDefault: false,
        //     touchEnabled: true,
        //     boxSelect: false,
        //     controls: {
        //         trash: true
        //     },
        //     styles,
        //     defaultMode: 'draw_polygon'
        // })
        props.draw.changeMode("draw_polygon")
        let featureId = props.draw.add(feature.geometry)
        return props.draw
        // props.draw = props.draw.deleteAll()
        // let newFeature = props.draw.add(feature)
        // props.map.addControl(props.draw)
        // draw.set(newFeature)
        // console.log(newFeature)
    }

    calculateArea(e, draw) {
        const data = draw.getAll();
        if (data.features.length > 0) {
            const area = turf.area(data) * 0.0001;
            const rounded_area = Math.round(area * 100) / 100;
            return rounded_area
        } else {
            return 0
            // if (e.type !== 'draw.delete')
            //     alert('Click the map to draw a polygon.');
        }
    }

    // public deleteLastVertex(props: any) {
    //     let map: mapboxgl.Map;
    //     let draw: MapboxDraw = props.draw;
    //     console.log("get all => ", props.draw.getAll())
    //     let feature = props.draw.getAll().features[0]

    //     // props.map.removeControl(props.draw)
    //     console.log(feature)
    //     let coords: Array<any> = feature.geometry.coordinates.filter(t => true)
    //     let popoedCoord = coords.pop();
    //     feature.geometry.coordinates = coords.filter(t => true)
    //     // props.draw.changeMode("direct_select", { featureId: feature.id })
    //     // props.draw.deleteAll()//delete(feature.id)
    //     // props.draw.trash()
    //     // console.log(feature.geometry)
    //     let featureIds = props.draw.add(feature.geometry)
    //     let startPoint = coords[coords.length - 1]
    //     props.draw.changeMode("draw_line_string", { featureId: featureIds[0], from: startPoint })
    //     console.log(props.draw.getAll())
    //     return props.draw
    // }

    public addMarkersArray(props: { map: mapboxgl.Map, flagsGeojson: Array<IGeoJSONObj>, callback, type }) {
        let markerList: Array<{ id: string, marker: mapboxgl.Marker }> = []
        props.flagsGeojson.forEach(el => {
            var doc = document.createElement('div');
            doc.className = el.properties.markerClassName;
            doc.style.backgroundImage = "url(/assets/images/" + props.type + "-flag.svg)";
            doc.id = 'marker-' + el.properties.id;
            doc.addEventListener('click', function (e) {
                e.stopPropagation();
                props.callback(el.properties.id)
            });
            let markerObj: mapboxgl.Marker
            markerObj = new mapboxgl.Marker(doc, { offset: [0, 0] })
            markerObj.setLngLat(el.geometry.coordinates as mapboxgl.LngLatLike)
            markerObj.setDraggable(false)
            markerObj.setPitchAlignment
            markerObj.addTo(props.map)
            markerList.push({ id: el.properties.id, marker: markerObj })
        });
        return markerList
    }


    addArrMarkerWithImage(map: any, markers: Array<{ geojson: any, className: string, image: string, farmId: number, type: string, existAllDevice: boolean }>, callback) {
        let markerList: Array<{ id: number, marker: mapboxgl.Marker }> = [];
        markers.forEach(e => {
            let center
            try {
                if (e.geojson.geometry.type == 'Polygon') {
                    center = this.getCenter(e.geojson.geometry.coordinates[0])
                } else {
                    center = e.geojson.geometry.coordinates
                }

            } catch (error) {
            }
            const el = document.createElement('div');
            el.addEventListener('click', function (el) {
                el.stopPropagation();
                callback(e.farmId, e.type, e.existAllDevice, center);
            });
            el.className = e.className;
            el.id = 'marker-' + e.farmId;
            el.style.backgroundImage = "url(" + e.image + ")";
            el.style.backgroundSize = 'cover';
            el.style.backgroundRepeat = 'no-repeat';
            let marker = new mapboxgl.Marker(
                el, { offset: [0, -5] })
                .setLngLat(center)
                .addTo(map);
            markerList.push({ id: e.farmId, marker: marker });
        });
        return markerList;
    }
    addMarkerWithImage(map: any, markers: { geojson: any, className: string, image: string, farmId: number, type: string, existAllDevice: boolean }, callback) {
        let center = markers.geojson.geometry.coordinates;
        const el = document.createElement('div');
        el.addEventListener('click', function (el) {
            el.stopPropagation();
            callback(markers, center);
        });
        el.className = markers.className;
        el.id = 'marker-' + markers.farmId;
        el.style.backgroundImage = "url(" + markers.image + ")";
        el.style.backgroundSize = 'cover';
        el.style.backgroundRepeat = 'no-repeat';
        let marker = new mapboxgl.Marker(
            el, { offset: [0, -5] })
            .setLngLat(center)
            .addTo(map);
        this.flyTo(map, { lat: center[1], lng: center[0] }, 14).subscribe();
        return { marker: marker };
    }
    getCenter(points: Array<any>) {
        var features = turf.points(points);
        return turf.center(features).geometry.coordinates;
    }



    public checkIsInPolygon(props: { polygonGeojson: Array<Array<Array<number>>>, coordinates }) {
        var point = turf.point(props.coordinates.reverse());
        var polygon = turf.polygon(props.polygonGeojson, { name: Date.now() + "" })
        return turf.inside(point, polygon)
    }

}